import React, { useContext, useReducer, createContext } from 'react'
import { useHistory } from 'react-router-dom'

import { getCurrentPage } from '../utils'

const PickupContext = createContext(undefined)

const initialValues = {
  showOnlyBooked: true,
  selectedBrandAmbassadors: undefined,
  selectedCampaigns: undefined,
  selectedClients: undefined,
  selectedCodes: undefined,
  selectedMerchTypes: undefined,
  selectedDays: undefined,
  selectedWeeks: undefined,
  selectedPreset: 0,
  clients: undefined,
  brandAmbassadors: undefined,
  campaigns: undefined,
  cityId: undefined,
  assignInventoryToUser: undefined,
  returnInventoryFromUser: undefined,
  history: undefined,
  errors: {},
  exportBrief: false,
  pickupType: undefined,
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'setShowOnlyBooked': {
      return { ...state, showOnlyBooked: action.payload }
    }
    case 'setSelectedBrandAmbassadors': {
      return { ...state, selectedBrandAmbassadors: action.payload }
    }
    case 'setSelectedCampaigns': {
      return { ...state, selectedCampaigns: action.payload }
    }
    case 'setSelectedClients': {
      return { ...state, selectedClients: action.payload }
    }
    case 'setSelectedCodes': {
      return { ...state, selectedCodes: action.payload }
    }
    case 'setSelectedMerchTypes': {
      return { ...state, selectedMerchTypes: action.payload }
    }
    case 'setSelectedDays': {
      return { ...state, selectedDays: action.payload }
    }
    case 'setSelectedWeeks': {
      return { ...state, selectedWeeks: action.payload }
    }
    case 'setSelectedPreset': {
      return { ...state, selectedPreset: action.payload }
    }
    case 'setExportBrief': {
      return { ...state, exportBrief: action.payload }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const usePickupContext = () => {
  const [pickupContextState, pickupContextDispatch] = useContext(PickupContext)

  const history = useHistory()
  pickupContextState.pickupType = getCurrentPage(history.location.pathname)

  const setShowOnlyBooked = value => {
    pickupContextDispatch({
      type: 'setShowOnlyBooked',
      payload: value,
    })
  }

  const setSelectedBrandAmbassadors = value => {
    pickupContextDispatch({
      type: 'setSelectedBrandAmbassadors',
      payload: value,
    })
  }

  const setSelectedCampaigns = value => {
    pickupContextDispatch({
      type: 'setSelectedCampaigns',
      payload: value,
    })
  }

  const setSelectedClients = value => {
    pickupContextDispatch({
      type: 'setSelectedClients',
      payload: value,
    })
  }

  const setSelectedCodes = value => {
    pickupContextDispatch({
      type: 'setSelectedCodes',
      payload: value,
    })
  }

  const setSelectedMerchTypes = value => {
    pickupContextDispatch({
      type: 'setSelectedMerchTypes',
      payload: value,
    })
  }

  const setSelectedDays = value => {
    pickupContextDispatch({
      type: 'setSelectedDays',
      payload: value,
    })
  }

  const setSelectedWeeks = value => {
    pickupContextDispatch({
      type: 'setSelectedWeeks',
      payload: value,
    })
  }

  const setSelectedPreset = value => {
    pickupContextDispatch({
      type: 'setSelectedPreset',
      payload: value,
    })
  }

  const setExportBrief = value => {
    pickupContextDispatch({
      type: 'setExportBrief',
      payload: value,
    })
  }

  return {
    setShowOnlyBooked,
    setSelectedBrandAmbassadors,
    setSelectedCampaigns,
    setSelectedClients,
    setSelectedCodes,
    setSelectedMerchTypes,
    setSelectedDays,
    setSelectedWeeks,
    setSelectedPreset,
    setExportBrief,
    pickupContextState,
    pickupContextDispatch,
  }
}

export const PickupProvider = ({
  children,
  initialValues: initialValuesProp,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialValues,
    ...initialValuesProp,
  })
  return (
    <PickupContext.Provider value={[state, dispatch]}>
      {children}
    </PickupContext.Provider>
  )
}
